import React from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import LoginView from "./views/Auth/Login/LoginView";
import PasswordResetView from "./views/Auth/PasswordReset/PasswordResetView";
import SignUpView from "./views/Auth/SignUp/SignUpView";
import AppBarComponent from "./views/components/AppBarComponent";
import Footer from "./views/components/FooterComponent";
import ApproveVendorsView from "./views/Events/organizer/ApproveVendorsView";
import CreateEditEventsView from "./views/Events/organizer/CreateEditEventsView";
import EventsHomeView from "./views/Events/EventsHomeView";
import ManageEventsView from "./views/Events/ManageEventsView";
import ExploreEventsView from "./views/Events/ExploreEventsView";
import HomeView from "./views/Home/HomeView";
import PrivacyPolicyView from "./views/PrivacyPolicy/PrivacyPolicyView";
import SupportView from "./views/Support/SupportView";
import TermsOfServiceView from "./views/TermsOfService/TermsOfServiceView";
import VendorViewV2 from "./views/Vendor/VendorViewV2";
import { SnackbarProvider } from "./context/SnackbarContext";
import AboutUs from "./views/Support/AboutUs";
import ProtectedRoute from "./utils/ProtectedRoute";
import EventView from "./views/Events/EventView";
import ExploreVendorView from "./views/Vendor/ExploreVendorView";
import CreateEditStorefrontView from "./views/Storefront/CreateEditStorefrontView";
import ManageStorefrontView from "./views/Storefront/ManageStorefrontView";
import UpdatePhotoView from "./views/Storefront/UpdatePhotoView";
import ManageStorefrontPermit from "./views/Storefront/ManageStorefrontPermit";
import OrganizerView from "./views/Events/organizer/OrganizerView";
import NotFoundView from "./views/Home/NotFoundView";

function App() {

  return (
    <>
      <SnackbarProvider>
        <Router>
          <AppBarComponent />
          <Routes>
            <Route path="/" element={<HomeView />} />
            <Route path="/:slug" element={<VendorViewV2 />} />
            <Route path="/_/login" element={<LoginView />} />
            <Route path="/_/signup" element={<SignUpView />} />
            <Route path="/_/password-reset" element={<PasswordResetView />} />
            <Route path="/_/privacy-policy" element={<PrivacyPolicyView />} />
            <Route path="/_/terms-of-service" element={<TermsOfServiceView />} />
            <Route path="/_/support" element={<SupportView />} />
            <Route path="/_/contact" element={<AboutUs />} />
            <Route path="/_/explore" element={<ExploreVendorView />} />

            <Route path="/_/storefront" element={<ProtectedRoute />}>
              <Route path="create" element={<CreateEditStorefrontView />} />
              <Route path="update/:slug" element={<CreateEditStorefrontView />} />
              <Route path="update/photos/items/:slug" element={<UpdatePhotoView />} />
              <Route path="update/photos/store/:slug" element={<UpdatePhotoView />} />
              <Route path="manage/permits/:slug" element={<ManageStorefrontPermit />} />
              <Route path="manage" element={<ManageStorefrontView />} />

            </Route>
            <Route path="/_/events" element={<EventsHomeView />} >
              <Route path="manage/:tabLocation?" element={<ProtectedRoute />}>
                <Route index element={<ManageEventsView />} />
              </Route>
              <Route path="organizer" element={<ProtectedRoute />}>
                <Route path="create" element={<CreateEditEventsView />} />
                <Route path="update/:slug" element={<CreateEditEventsView />} />
                <Route path="approve/:slug" element={<ApproveVendorsView />} />
              </Route>
              {/* <Route path="vendor" element={<ProtectedRoute />}></Route> */}
              <Route path="explore" element={<ExploreEventsView />} />
            </Route>
            <Route path="/event/:slug" element={<EventView />} />
            <Route path="/org/:slug" element={<OrganizerView />} />
            <Route path="*" element={<NotFoundView />} />
          </Routes>
        </Router>
        <Footer />
      </SnackbarProvider>
    </>
  );
}

export default App;
